import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button} from 'ui-library';

import * as campaignsActions from 'redux/modules/campaigns';
import * as appActions from 'redux/modules/app';
import SocialAvatarInfluencer from 'modules/legacy/js/components/social-avatar-influencer';
import {Dialog, Avatar} from 'modules/legacy/js/lib/components';
import InfoHelper from 'modules/shared/components/InfoHelper';
import i18n from 'i18n';

const REQUEST_ACCEPT_INVITE_ID = 'acceptInvite';

function mapStateToProps({app, socialAccounts}) {
  const {requests} = app;
  const {systemSettings} = app;
  const {currency} = systemSettings
  return {
    acceptInviteRequest: requests[REQUEST_ACCEPT_INVITE_ID],
    configuration: socialAccounts.configuration,
    currency
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    resetRequest: appActions.resetRequest,
    acceptInvite: campaignsActions.acceptInvite,
    joinCampaign: campaignsActions.joinCampaign
  }, dispatch);
}

class ConfirmParticipationDialog extends Component {
  static propTypes = {
    onAccept: PropTypes.func,
    onClose: PropTypes.func,
    socialAccount: PropTypes.object,
    campaign: PropTypes.object,
    postPrice: PropTypes.number,
    influencerFee: PropTypes.number,
    influencerPayment: PropTypes.number,
    acceptInvite: PropTypes.func,
    inviteId: PropTypes.string,
    resetRequest: PropTypes.func,
    acceptInviteRequest: PropTypes.object,
    currency: PropTypes.object.isRequired,
    children: PropTypes.node,
    configuration: PropTypes.object.isRequired,
    daysForPayment: PropTypes.string
  }

  static defaultProps = {
    onAccept: () => {},
    onClose: () => {},
    socialAccount: {},
    campaign: {},
    postPrice: 0,
    influencerFee: 0,
    influencerPayment: 0,
    acceptInvite: () => {},
    inviteId: '',
    resetRequest: () => {},
    acceptInviteRequest: {},
    children: null,
    daysForPayment: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      disableAcceptButton: false
    };
  }

  componentWillReceiveProps = (props) => {
    const {acceptInviteRequest} = props;

    if (acceptInviteRequest.status === 'success') this.onAcceptInvite(props);
    if (acceptInviteRequest.status === 'fail') this.onAcceptInvite(props);
  }

  onAcceptInvite = (props) => {
    const {acceptInviteRequest} = props;
    const {response} = acceptInviteRequest;
    this.props.resetRequest(REQUEST_ACCEPT_INVITE_ID);
    this.props.onAccept(response);
  }

  acceptInvite = () => {
    const {acceptInvite, inviteId} = this.props;

    this.setState({disableAcceptButton: true});
    return acceptInvite(inviteId);
  }

  render = () => {
    const {
      socialAccount,
      campaign,
      postPrice,
      influencerFee,
      influencerPayment,
      children,
      configuration,
      daysForPayment, 
      currency
    } = this.props;

    const currencySuffix = get(currency,'suffix','');

    return (
      <Dialog
        size='sm'
        header={<span>{i18n.get('INF_VOXEAR_CAMPAIGN_CONFIRM_INVITATION')}</span>}
        dismissable={!this.state.disableAcceptButton}
        closeIconClassName={this.state.disableAcceptButton ? 'no-visibility' : ''}
        onClose={this.props.onClose}
        content={
          <div className='flex width100 padding-1x'>
            <div className='flex-column flex-align-center width100'>
              <div className='flex width100 margin-bottom-1x'>
                <div className='col-xs-3 flex between-xs no-padding'>
                  <Avatar image={campaign.brandImage} size='md' />
                </div>

                <div className='col col-xs-9'>
                  <h2
                    className='ellipsis'
                    data-uitest='campaign-name'
                  >
                    {campaign.name}
                  </h2>
                  <span className='vf-font-normal ellipsis'>
                    {campaign.brandName}
                  </span>
                </div>
              </div>

              <div
                data-uitest='modal-payment-per-message'
                className='flex width100 flex-justify-space-between'
              >
                <div>
                  {i18n.get('INF_VOXEAR_CAMPAIGN_BRIEF_PAYMENT_PER_MESSAGE')}
                </div>
                <div>
                  {i18n.getMoney({ amount: postPrice, currency: currencySuffix })}
                </div>
              </div>

              <div data-uitest='modal-payment-per-message-fee' className='flex width100 padding-vertical-Hx flex-justify-space-between'>
                <div className='flex'>
                  <div>
                    {i18n.get('INF_VOXEAR_CAMPAIGN_BRIEF_PAYMENT_PER_MESSAGE_FEE')}
                  </div>
                  <div className='padding-left-Hx'>
                    <InfoHelper
                      className='vf-bg-gray-dark-color'
                      popoverPosition='above'
                      popoverBody={
                        <div className='padding-Hx'>
                          <p className='margin-bottom-Hx'>{i18n.get('INF_VOXEAR_CAMPAIGN_CONFIRM_INVITATION_INFLUENCER_FEE_DISCLAIMER')}</p>
                          <a
                            href={i18n.get('HELP_LINKS_CHARGE_FOR_SERVICE')}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {i18n.get('INF_VOXEAR_CAMPAIGN_CONFIRM_INVITATION_INFLUENCER_FEE_DISCLAIMER_LINK')}
                          </a>
                        </div>
                      }
                    />
                  </div>
                </div>
                <div>
                  {i18n.getMoney({ amount: influencerFee, currency: currencySuffix })}
                </div>
              </div>

              <div data-uitest='modal-payment-per-message-total' className='flex width100 flex-justify-space-between'>
                <div>
                  {i18n.get('INF_VOXEAR_CAMPAIGN_BRIEF_PAYMENT_PER_MESSAGE_TOTAL')}
                </div>
                <div>
                  {i18n.getMoney({ amount: influencerPayment, currency: currencySuffix })}
                </div>
              </div>

              <div className='text-align-left margin-vertical-2x'>
                {children}
              </div>

              <div className='flex width100 flex-justify-space-between margin-bottom-1x'>
                <div>
                  <SocialAvatarInfluencer socialAccount={socialAccount} />
                </div>

                <div>
                  <div className='vf-font-big ellipsis vf-primary-text text-align-right' data-uitest='campaign-name'>
                    {i18n.getMoney({ amount: influencerPayment, currency: currencySuffix })}
                  </div>
                  <div className='vf-font-normal ellipsis'>
                    {i18n.get('INF_VOXEAR_OPEN_CAMPAIGN_CONFIRMATION_CONFIRM_PER_POST')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        footer={
          <div className='margin-vertical-2x flex flex-col'>
            <div className='flex padding-horizontal-1x text-align-left vf-font-small'>
              <p>
                {i18n.get('INF_VOXEAR_CAMPAIGN_CONFIRM_INVITATION_PAYMENT_DISCLAIMER', {
                  days: daysForPayment || configuration.daysForPayment
                })}
              </p>
            </div>
            <div className='flex flex-justify-center padding-horizontal-Hx'>
              <div className='padding-left-Hx padding-right-1x'>
                <Button
                  size='sm'
                  data-uitest='accept-button'
                  color='primary'
                  onClick={this.acceptInvite}
                  disabled={this.state.disableAcceptButton}
                >
                  {i18n.get('ACCEPT')}
                </Button>
              </div>
            </div>
          </div>
        }
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmParticipationDialog);
